import { useLanguage } from '../context/LanguageContext';
import { translate } from '../i18n/translations';

const useTranslation = () => {
  const { language } = useLanguage();
  const t = (key, fallback, values) => translate(language, key, fallback, values);
  return { t, language };
};

export default useTranslation;
